import { useEffect, useRef } from "react";
import { useMsal } from "@azure/msal-react";
import { Outlet } from "react-router-dom";
import { checkTokenExpiry } from "../utils/authUtils";
import { setMsalInstance } from "../utils/fetch";
import { InteractionStatus } from "@azure/msal-browser";


const AuthGuard = () => {
  const { instance, accounts, inProgress } = useMsal();
  const loginTriggeredRef = useRef(false);

useEffect(() => {
    if (inProgress === InteractionStatus.None) {
      instance
        ?.handleRedirectPromise()
        .then((response) => {
          setMsalInstance(instance);
          if (response) {
            processLogin(response);
          } else if (accounts?.length === 0) {
            handleLogin();
          }
        })
        .catch((error) => console.log("Error during redirect:", error));
    } else if (
      localStorage.getItem("accessToken") !== undefined &&
      localStorage.getItem("accessToken") !== null
    ) {
      // debugger;
      setMsalInstance(instance);

      //--TODO POST LOGIN ACTIONS
      
    }
  }, [instance, accounts, inProgress]);

  const processLogin = (response) => {
    if (!response?.accessToken) return;

    const isExpired = checkTokenExpiry(response?.accessToken);
    if (isExpired) {
      localStorage.clear();
      instance?.logoutRedirect();
    } else {
      // debugger;
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("accessToken", response?.accessToken);
      localStorage.setItem("userName", response?.account.name);
      localStorage.setItem("userEmail", response?.account.username);
    }
  };

  const handleLogin = () => {
    const loginRequest = {
      scopes: [process.env.REACT_APP_CLIENT_ID + "/.default"],
    };
    instance?.loginRedirect(loginRequest);
  };

  if (accounts.length === 0) {
    return null;
  }

  return <Outlet />;
};

export default AuthGuard;